//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { getConfirm } from "../../model/api/confirmService.js";
export default {
  name:'inform',
  data(){
    return {
      templateFlag:'tk_irok',// 保险标示
      show:true,
      supplier:'',
      logo:'',
    }
  },
  components:{
  },
  
  created() {
    if(this.$route.query.templateFlag){
      this.templateFlag = this.$route.query.templateFlag;
    }
    
  },
  mounted(){
    this.STATISTICS_CONFIG.insur_firstinfo_page()
    // 解决ios返回 展示空白页bug
    if(this.IOS_AND == 'IOS') {
      document.scrollingElement.scrollTop = 1
    }
    getConfirm(this.templateFlag).then((data) =>{
      this.logo = data.logo
      this.supplier=data.supplier
      this.$emit("getbizKey",data.traceback)

    })
  },
  methods:{
    handler(ev){
        ev.preventDefault();
    },
    showToast(){
      this.show = true;
      document.body.addEventListener('touchmove', this.handler, { passive: false });
    },
    close(){
      this.show = false;
      document.body.removeEventListener('touchmove', this.handler, { passive: false });
      this.STATISTICS_CONFIG.insur_firstinfo_submit_click()
    },
    pdfClick(){
        this.$router.push({
            path: "/pdf",
            query:{
                insurFlag:'confirm',
                pdfFlag:'confirmPdf',
                flag:'postdisable'
            }
        });
    }
  }
}
